// extracted by mini-css-extract-plugin
module.exports = {"container":"LatestPosts-module--container--WQlrq","header":"LatestPosts-module--header--3Iaya","postsContainer":"LatestPosts-module--postsContainer--1xgZ-"};